import { React, useState } from "react";
import ImageGallery from "react-image-gallery";
import { Modal, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const BannerPropiedad = ({ propiedad, ruta }) => {

    const { t } = useTranslation();
    const fotos = propiedad.fotos_web;

    return (
        <>
            <section className="photo_grid photoGrid_sizeLarge mt25">
                <div className="container">
                    <div className="inner">
                        <ul>
                            {
                                fotos.length > 0 ?
                                    fotos[0].nombre.includes("https") ?
                                        <li>
                                            <img src={fotos[0].nombre} className="imgpropiedad"></img>
                                        </li>
                                        :
                                        <li>
                                            <img src={ruta + "/propiedades/" + propiedad.id + "/fotos/web/" + fotos[0].nombre} className="imgpropiedad"></img>
                                        </li>

                                    :
                                    <li>
                                        <img src="/images/web/bedloop-nofoto.png" className="imgpropiedad"></img>
                                    </li>
                            }
                        </ul>
                    </div>
                </div>
            </section>
        </>
    );
}

export default BannerPropiedad;
